import { useEffect } from 'react';
import { useAppConstantsContext } from '@/context/AppConstants';
import { Text, ProgressBar, Stack } from '@/theme/index';
import {
  DivisorLine,
  OnboardingImg,
  InlineContainer,
  ContentContainer,
} from './components';
import {
  ActiveComponent,
  ActiveComponentProps,
  QuestionsSurveyProps,
} from './constants';
import { useOnboardingWizard } from '../index';

export function QuestionsSurvey({ questionsSet }: QuestionsSurveyProps) {
  const {
    activeQuestion,
    storeQuestionAnswer,
    displayBackBtn,
    prevQuestion,
    questionSwitching,
    progressBarPercentage,
    skipOnboardingQuestions,
  } = useOnboardingWizard(questionsSet);
  const inputType = activeQuestion.response.input_type;
  const ComponentToRender =
    ActiveComponent[inputType as keyof ActiveComponentProps];
  const {
    images: { imgCheckList },
  } = useAppConstantsContext();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [activeQuestion]);

  return (
    <>
      <ProgressBar
        value={progressBarPercentage}
        variant="determinate"
        sx={{ height: [16, 14] }}
      />
      <ContentContainer>
        <Stack
          id={`container-${activeQuestion.screen_id}`}
          sx={{ transition: '1s ease-in-out' }}
        >
          <InlineContainer>
            {displayBackBtn && !questionSwitching && (
              <Text
                variant="h4"
                fontSize={16}
                color="primary"
                sx={{
                  cursor: 'pointer',
                  textDecoration: 'underline',
                  position: 'absolute',
                }}
                onClick={() => prevQuestion()}
              >
                &lt; Go Back
              </Text>
            )}
            <OnboardingImg
              src={imgCheckList}
              alt="checklist"
              width={80}
              height={80}
            />
          </InlineContainer>
          <Text
            variant="h1"
            color="primary"
            textAlign="center"
            sx={{ fontSize: [20, 24], marginBottom: 4, marginTop: [3, 4] }}
          >
            {activeQuestion.page_header}
          </Text>
          <Text
            variant="h2"
            color="primary"
            textAlign="center"
            sx={{ fontSize: [24, 40], marginBottom: [3, 5] }}
          >
            {activeQuestion.question_text}
          </Text>
          <ComponentToRender
            inputType={inputType}
            storeAnswer={storeQuestionAnswer}
            screenId={activeQuestion.screen_id}
            answerSet={
              activeQuestion.response.answer_set
                ? activeQuestion.response.answer_set.map((item) => String(item))
                : []
            }
            customAttribute={
              activeQuestion.response.custom_attribute !== null &&
              activeQuestion.response.custom_attribute !== undefined
                ? activeQuestion.response.custom_attribute
                : ''
            }
          />
        </Stack>
        <div>
          {!questionSwitching && (
            <Text
              variant="h4"
              fontSize={16}
              color="primary"
              sx={{
                cursor: 'pointer',
                textDecoration: 'underline',
                marginBottom: 0,
                marginTop: 2,
              }}
              onClick={() => skipOnboardingQuestions()}
            >
              Skip &gt;
            </Text>
          )}
          <DivisorLine />
        </div>
      </ContentContainer>
    </>
  );
}
